import { useState } from 'react';
import Button from 'src/components/buttons/button';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li>
        <div className="navigator__contents__number">1.</div>
        <div className="navigator__contents__content-text">
          <a href="#1">Fats explained</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">2.</div>
        <div className="navigator__contents__content-text">
          <a href="#2">What does fat do to the body?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">3.</div>
        <div className="navigator__contents__content-text">
          <a href="#3">Saturated fat myths cleared up</a>
        </div>
      </li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">{'Week 6: Saturated fat'}</h1>
      <p>
        Diets high in saturated fats have been linked to high cholesterol. To get your cholesterol back to a healthier
        level, you should try to eat less saturated fat. This week we’ll explain the different types of fat and how they
        affect your body.
      </p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>Fats explained</h2>
      <p>
        We all need some fat from the food we eat. It is a major source of energy, it helps you to absorb certain
        vitamins and minerals and keeps you warm. But some fats are good for us, while other fats can lead to heart and
        circulatory diseases. Trans fats and saturated fats are the ones you need to cut down on if you want to reduce
        your risk of a heart attack or a stroke.{' '}
      </p>
      <img alt="Olive oil" className="navigator__image-full" src={`${PROGRAM_URL}W06B01.jpg`} />
      <a
        href="https://www.bhf.org.uk/heart-health/preventing-heart-disease/healthy-eating/fats-explained"
        rel="noreferrer"
        target="_blank"
      >
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text="Tips to eat less saturated fat"
        />
      </a>

      <h2>What does fat do to the body?</h2>
      <p>
        All these different types of fat can be confusing, because they mean different things for your body. Watch this
        short video to understand the differences between these fats and how to eat them in a way that will help bring
        your cholesterol to a healthier level.
      </p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/HPk2vM6CInM"
        />
      </div>

      <h2>Saturated fat myths cleared up</h2>
      <p>
        Eating high amounts of saturated fat can increase your blood cholesterol. However, there is conflicting evidence
        about how big an impact saturated fat has on our overall health. BHF Senior Dietician Tracy Parker sorts the
        myths from the facts in this video.
      </p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/5oy0Tl8GA8I"
        />
      </div>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="HealthUnlocked British Heart Foundation community screenshot" className="navigator__footer__image" src={`${PROGRAM_URL}cta-community.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">Join the conversation on HealthUnlocked</div>
        <div className="navigator__footer__description">
          To get the most out of your heart health journey, you’ll need support. Our online community on
          HealthUnlocked brings patients, their loved-ones and healthcare experts all together online to share advice
          and encouragement.{' '}
          <a
            className="navigator__footer__link"
            href="https://healthunlocked.com/bhf"
            rel="noreferrer"
            target="_blank"
          >
            Join the conversation {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Lower your cholesterol | HealthUnlocked',
};

export default obj;
